export const pageContent = {
  title: 'LIBRARY',
  description: 'LIBRARY_DESCRIPTION',
  configCard: {
    title: 'Your Configuration',
    entityLabel: 'Entity:',
    industryLabel: 'Industry:'
  },
  modulesSection: {
    title: 'Applicable Modules',
    description:
      'Based on your Who Am I configuration, the following modules are applicable to your organization. Select the modules you want to work with:'
  },
  libraryTools: {
    title: 'Library Tools',
    items: [
      {
        key: 'dataEntry',
        title: 'DATA_ENTRY',
        description: 'DATA_ENTRY_DESCRIPTION',
        href: '/library/data-entry'
      },
      {
        key: 'reporting',
        title: 'REPORTING',
        description: 'REPORTING_DESCRIPTION',
        href: '/library/reporting'
      }
    ]
  },
  buttons: {
    saveSelections: 'Save Selections',
    proceedToControlHub: 'Proceed to Control Hub'
  },
  tools: {
    dataEntry: 'DATA_ENTRY',
    dataEntryDescription: 'DATA_ENTRY_DESCRIPTION',
    reporting: 'REPORTING',
    reportingDescription: 'REPORTING_DESCRIPTION'
  }
};

export const moduleCategories = {
  core: 'Core Module',
  advanced: 'Advanced Module',
  specialized: 'Specialized Module'
};

export const gridConfig = {
  modules: {
    xs: 24,
    sm: 12,
    md: 6,
    lg: 4
  },
  tools: {
    xs: 24,
    sm: 12,
    md: 6,
    lg: 4
  },
  gutter: [16, 16] as [number, number],
  toolsGutter: [24, 24] as [number, number]
};
